import React from 'react';

const AssignViewContext = React.createContext(false);

export default AssignViewContext;
